// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    if (!image.matches(':hover')) {
      image.style.opacity = '100%';
      return;
    }
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio, overlay) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function openMediaModal(image) {
  image.closest('.product__modal-opener--image')?.querySelector('.product__media-toggle')?.click();
}

function magnify(image, event, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => {
    overlay.remove();
    openMediaModal(image);
  };
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio, overlay);
  overlay.onmouseleave = () => overlay.remove();
  moveWithHover(image, event, zoomRatio, overlay);
}

function enableZoomOnHover(zoomRatio) {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const images = document.querySelectorAll(
    'product-info[data-zoom-on-hover] .product__modal-opener--image .product__media img'
  );
  images.forEach((image) => {
    image.onmouseenter = (event) => magnify(image, event, zoomRatio);
    image.onclick = () => openMediaModal(image);
  });
}

enableZoomOnHover(2);
